import React from 'react';
import { useQuery } from 'react-query';
import api from '../../services/api';
import { Video } from 'lucide-react';

export default function ConferencesPage() {
  const { data = [] } = useQuery('conferences', () => api.get('/conferences').then(r => r.data));
  return (
    <div className="space-y-6">
      <div><h1 className="text-2xl font-bold text-white">Salas de Conferencia</h1></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {data.map(room => (
          <div key={room.id} className="card">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-indigo-600/20 rounded-xl flex items-center justify-center">
                <Video size={18} className="text-indigo-400" />
              </div>
              <div>
                <div className="font-semibold text-white">{room.name}</div>
                <div className="text-xs text-gray-400">Ext. {room.number} | Max: {room.max_participants}</div>
              </div>
            </div>
            <div className="mt-2 flex gap-2 text-xs">
              {room.pin && <span className="badge-warning">PIN requerido</span>}
              {room.record_enabled && <span className="badge-info">Grabacion</span>}
            </div>
          </div>
        ))}
        {!data.length && <div className="card col-span-3 text-center py-12 text-muted">Sin salas configuradas</div>}
      </div>
    </div>
  );
}
